// extracted by mini-css-extract-plugin
module.exports = {"prize":"Prize_prize__oLjfK"};